import { useEffect, useState } from 'react'

function readWindowSize() {
  return typeof window !== 'undefined'
    ? { width: window.innerWidth, height: window.innerHeight }
    : undefined
}

const listeners = new Set()

function handleResize() {
  const size = readWindowSize()
  listeners.forEach((setWindowSize) => setWindowSize(size))
}

export default function useWindowSize() {
  const [windowSize, setWindowSize] = useState(readWindowSize)

  useEffect(() => {
    if (typeof window === 'undefined') return undefined

    if (listeners.size === 0) {
      window.addEventListener('resize', handleResize)
    }
    listeners.add(setWindowSize)

    return () => {
      listeners.delete(setWindowSize)
      if (listeners.size === 0) {
        window.removeEventListener('resize', handleResize)
      }
    }
  }, [])

  return windowSize
}
